module.exports = __webpack_public_path__ + "fonts/2F59F3_6_0.c44ac31.woff2";